// src/components/ActionButton.js
import React from 'react';

// Componente ActionButton: renderiza un enlace o un botón dependiendo de si se proporciona una URL.
// target se determina en función del ancho de la ventana: en escritorio se abre en _blank, en móvil en _self.
const ActionButton = ({ label, url, onClick, disabled }) => {
  // Determinar el target basado en el tamaño de la ventana
  const target = window.innerWidth >= 768 ? '_blank' : '_self';

  // Si se proporciona una URL, renderizamos un enlace (<a>).
  if (url) {
    return (
      <a
        href={url}
        target={target}
        rel="noopener noreferrer"
        className="prof-button"
        onClick={onClick}
      >
        {label}
      </a>
    );
  } else {
    // Si no hay URL, renderizamos un botón deshabilitado.
    return (
      <button
        className="prof-button"
        disabled={disabled}
        style={{ backgroundColor: '#ccc', color: '#0093F5', cursor: 'default' }}
      >
        {label}
      </button>
    );
  }
};

export default ActionButton;
